// Enhance accessibility with additional event listeners
const tabs = document.querySelectorAll(".js-tab-nav");

tabs.forEach(function (tab) {
  tab.addEventListener("keydown", function (e) {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      const tabRadio = document.getElementById(e.target.htmlFor);
      tabRadio.checked = true;
    }
  });
});
